import React, { useState } from 'react'
import { Button, Tr, Td } from '@chakra-ui/react'

import EditRentalAddOnModal from './EditRentalAddOnModal'
import type { RentRollAddOn } from './index'

type AddOnRowProps = {
  addOn: RentRollAddOn
  onSuccess?: () => void
  occupancyDate: string
}

export default function AddOnRow({ addOn, onSuccess, occupancyDate }: AddOnRowProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const {
    end_date: endDate,
    liability_type: { name },
    price,
    start_date: startDate
  } = addOn

  return (
    <>
      <Tr>
        <Td>{name}</Td>
        <Td>{`$${price}`}</Td>
        <Td>{startDate}</Td>
        <Td>{endDate}</Td>
        <Td>
          <Button size='sm' colorScheme='teal' onClick={() => setIsModalOpen(true)}>
            Edit
          </Button>
        </Td>
      </Tr>
      <EditRentalAddOnModal
        addOn={addOn}
        close={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
        onSuccess={onSuccess}
        occupancyDate={occupancyDate}
      />
    </>
  )
}
